import React, { ReactElement } from 'react';

import { ChangeEvent } from '@philips-emr/tws-core/lib/component/types';
import { isFunction } from '@philips-emr/tws-utils';

import './native-select.scss';

export interface Option {
  key: string;
  label?: string;
}

export interface NativeSelectProps {
  data: Option[];
  onChange: (event: ChangeEvent<string>) => void;
  value: Option;
}

function NativeSelect(props: NativeSelectProps): ReactElement | null {
  const { data = [], onChange, value = { key: '' } } = props;

  if (!Array.isArray(data)) {
    return null;
  }

  const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    if (!isFunction(onChange)) {
      return;
    }

    onChange(new ChangeEvent({
      oldValue: value,
      value: data.find((item) => item.key === event.target.value),
    }));
  };

  return (
    <select className="c-native-select" value={value.key || ''} onChange={onChangeHandler}>
      <option value=""></option>
      {data.map(({ key, label }) => (
        <option key={key} value={key}>{label}</option>
      ))}
    </select>
  );
}

export default NativeSelect;
